(() => {
  const targetId = 'WinewizardHome';
  const linkSelector = '[data-vinalchemy-winewizard-scroll]';
  let animationFrame = 0;

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setAddressHash = (mode) => {
    const nextAddress = `${window.location.pathname}${window.location.search}#${targetId}`;

    try {
      if (mode === 'push') {
        window.history.pushState(window.history.state, '', nextAddress);
      } else {
        window.history.replaceState(window.history.state, '', nextAddress);
      }
    } catch (_error) {
      // Shopify's draft preview may restrict history changes. Scrolling must still work.
    }
  };

  const stickyHeaderOffset = () => {
    const header = document.querySelector('.section-header.shopify-section-header-sticky');
    if (!header) return 20;

    const cssHeight = Number.parseFloat(
      window.getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
    );
    const measuredHeight = header.getBoundingClientRect().height;
    return Math.ceil(Math.max(measuredHeight, Number.isFinite(cssHeight) ? cssHeight : 0)) + 20;
  };

  const destination = (target) => Math.max(
    0,
    window.scrollY + target.getBoundingClientRect().top - stickyHeaderOffset(),
  );

  const focusTarget = (target) => {
    try {
      target.focus({ preventScroll: true });
    } catch (_error) {
      target.focus();
    }
  };

  const animateTo = (target, duration = 1100) => {
    window.cancelAnimationFrame(animationFrame);
    animationFrame = 0;

    const start = window.scrollY;
    const finish = destination(target);
    const change = finish - start;

    if (reducedMotion() || Math.abs(change) < 2) {
      window.scrollTo(0, finish);
      focusTarget(target);
      return;
    }

    const startedAt = window.performance.now();
    const step = (now) => {
      const progress = Math.min(1, (now - startedAt) / duration);
      const eased = progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      window.scrollTo(0, start + change * eased);
      if (progress < 1) {
        animationFrame = window.requestAnimationFrame(step);
      } else {
        animationFrame = 0;
        focusTarget(target);
      }
    };

    animationFrame = window.requestAnimationFrame(step);
  };

  const scrollToWinewizard = (updateAddress) => {
    const target = document.getElementById(targetId);
    if (!target) return false;

    animateTo(target);
    if (updateAddress && window.location.hash !== `#${targetId}`) {
      setAddressHash('push');
    }
    return true;
  };

  const cancelAnimation = () => {
    if (!animationFrame) return;
    window.cancelAnimationFrame(animationFrame);
    animationFrame = 0;
  };

  window.addEventListener('wheel', cancelAnimation, { passive: true });
  window.addEventListener('touchstart', cancelAnimation, { passive: true });
  window.addEventListener('keydown', (event) => {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) {
      cancelAnimation();
    }
  });

  window.addEventListener('click', (event) => {
    const link = event.target.closest(linkSelector);
    if (!link || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    if (link.hash !== `#${targetId}`) return;
    if (!document.getElementById(targetId)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    scrollToWinewizard(true);
  }, true);

  const runArrivalScroll = () => {
    const pendingArrival = Boolean(window.__vinalchemyWinewizardScrollPending);
    if (!pendingArrival && window.location.hash !== `#${targetId}`) return;
    if (!document.getElementById(targetId)) return;

    window.__vinalchemyWinewizardScrollPending = false;
    setAddressHash('replace');
    window.scrollTo(0, 0);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => scrollToWinewizard(false));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runArrivalScroll, { once: true });
  } else {
    runArrivalScroll();
  }

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted || window.location.hash !== `#${targetId}`) return;
    window.requestAnimationFrame(() => scrollToWinewizard(false));
  });
})();
